<!--
 * @Description: 申请 审批/办理 意见
 * @Author: peifu
 * @Date: 2022-12-21 15:19:33
 * @LastEditors: PF
 * @LastEditTime: 2023-06-21 17:21:56
-->
<template>
  <div>
    <el-dialog class="w500 h400" :model-value="isYiJian" :title="title" :before-close="handleClose" :close-on-click-modal="false" destroy-on-close>
      <el-input class="mt10" v-model="yj" :rows="8" type="textarea" placeholder="请输入审批意见" resize="none"/>
      <template #footer>
        <div style="flex: auto">
          <el-button type="primary" @click="quedingClick">确定</el-button>
          <el-button @click="handleClose">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits } from 'vue'
import { liuzhuanbuzhou } from '@/api/home.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
const props = defineProps({
  isYiJian: {
    type: Boolean,
    required: true
  },
  yiJianObj: {
    type: Object,
    required: false
  }
})
const title = ref()
const yj = ref('') // 审批/办理 意见
const ryid = ref() // 人员id

const emits = defineEmits(['update:isYiJian', 'yiJianReturn'])

// 审批/办理 确定
const quedingClick = () => {
  const obj = {
    splzbzID: ryid.value,
    zt: 9, // 状态：0-未开始，1-审批中，3-办理中，9-通过/办理，10-拒绝
    yj: yj.value // 办理意见
  }
  liuzhuanbuzhou(obj).then((res) => {
    yj.value = ''
    if (res.code === 200) {
      handleClose()
      emits('yiJianReturn')
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 关闭
const handleClose = () => {
  yj.value = ''
  emits('update:isYiJian', false)
}
watch(
  () => props.isYiJian,
  () => {
    if (props.isYiJian) {
      
      title.value = props.yiJianObj.title || ''
      ryid.value = props.yiJianObj.ryid || ''
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.NumberColumns_1) {
  height: 300px !important;
}
</style>
